import { render } from "./AboutView.vue?vue&type=template&id=74b1d3c3"
const script = {}

import exportComponent from "/Users/corrieleech/Actualize/booksmart-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__